import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import ExhibitorsList from './ExhibitorsList';
import SearchBar from '../../layout/searchBar/SearchBar';


const propTypes = {
  onFilterSubmit: PropTypes.func.isRequired,
  filter: PropTypes.string,
};

const ExhibitorsWrapper = (props) => (
  <div className="ui stackable equal width grid">
    <div className="row">
      <div className="column">
        <h2 className="ui header">
          <FormattedMessage
            id="exhibitors"
            description="Exhibitors menu item"
          />
        </h2>
      </div>
      <div className="column">
        <SearchBar onFilterSubmit={props.onFilterSubmit} filter={props.filter} />
      </div>
    </div>
    <div className="row">
      <div className="column">
        <ExhibitorsList {...props} />
      </div>
    </div>
  </div>
);

ExhibitorsWrapper.propTypes = propTypes;

export default ExhibitorsWrapper;



/** WEBPACK FOOTER **
 ** ./src/components/screens/exhibitors/ExhibitorsWrapper.js
 **/